import HttpClientXml from "../utils/HttpClientXml";

const addBlog = async (data) => {
  let endPoint = "add-blog";
  return HttpClientXml.post(endPoint, data);
};

const getBlog = async (data) => {
  let endPoint = "view-blog";
  return HttpClientXml.get(endPoint, data);
};
const getAllStaffs = async (data) => {
  let endPoint = "staff";
  return HttpClientXml.get(endPoint, data);
};

const updateBlog = async (id, data) => {
  let endPoint = `update-blog/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const deleteBlog = async (id) => {
  let endPoint = `delete-blog/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const viewUserContact = async (data) => {
  let endPoint = "view-contactus";
  return HttpClientXml.get(endPoint, data);
};

const viewAppointmentData = async (data) => {
  let endPoint = "view-bookinglist";
  return HttpClientXml.get(endPoint, data);
};

const viewUserEmail = async (data) => {
  let endPoint = "view-email";
  return HttpClientXml.get(endPoint, data);
};

const viewWaitListAppointment = async () => {
  let endPoint = "view-waitinglist";
  return HttpClientXml.get(endPoint);
};

const viewCancelAppointment = async () => {
  let endPoint = "cancelled-booking";
  return HttpClientXml.get(endPoint);
};

const cancelAppointmentById = async (id) => {
  let endPoint = `cancel-booking/${id}`;
  return HttpClientXml.put(endPoint);
};

const getTime = async () => {
  let endPoint = "view-timing";
  return HttpClientXml.get(endPoint);
};

const getInitialBookignAppointment = async () => {
  let endPoint = "view-booking-initial-beforepayment";
  return HttpClientXml.get(endPoint);
};
// /view-booking-initial-beforepayment

const rescheduleBooking = async (id, data) => {
  let endPoint = `resecdule-booking/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const viewBookingTimeByDate = async (data) => {
  let endPoint = "available-time-by-date";
  return HttpClientXml.post(endPoint, data);
};

const blockDateTime = async (data) => {
  let endPoint = "add-blockdatetime";
  return HttpClientXml.post(endPoint, data);
};

const viewblockDateTime = async () => {
  let endPoint = "view-blockdatetime";
  return HttpClientXml.get(endPoint);
};

const viewUrgentblockDateTime = async (id) => {
  let endPoint = "view-blockonlydate-urgent/" + id;
  return HttpClientXml.get(endPoint);
};

const viewblockByDateAndTime = async (data) => {
  let endPoint = "view-block-date-and-time";
  return HttpClientXml.post(endPoint, data);
};

const viewUrgentBlockByDateAndTime = async (data) => {
  let endPoint = "view-block-date-and-time-urgent";
  return HttpClientXml.post(endPoint, data);
};

const serviceTypeId = async (data) => {
  let endPoint = "servicewise-appointment";
  return HttpClientXml.post(endPoint, data);
};

const viewBlockdate = async (id) => {
  let endPoint = "view-blockdate/" + id;
  return HttpClientXml.get(endPoint);
};

const viewUrgentBlockdate = async () => {
  let endPoint = "view-blockdatetime-urgent";
  return HttpClientXml.get(endPoint);
};

const viewAllBlockedDateTime = async () => {
  let endPoint = "view-all-blockdatetime";
  return HttpClientXml.get(endPoint);
};

const viewAllUrgentAppointment = async () => {
  let endPoint = "view-urgent-book";
  return HttpClientXml.get(endPoint);
};

const deleteBlockedDate = async (id) => {
  let endPoint = `delete-blockdate-only/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const urgentDeleteBlockedDate = async (id) => {
  let endPoint = `delete-blockdate-only-urgent/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

// delete user contact details by id
const userContactDetails = async (id) => {
  let endPoint = `delete-contactus/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
const deleteStaff = async (id) => {
  let endPoint = `staff/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const deleteAllBlockedDate = async (data) => {
  let endPoint = "unblock-date-time";
  return HttpClientXml.put(endPoint, data);
};

const urgentDeleteAllBlockedDate = async (data) => {
  let endPoint = "unblock-date-time-urgent";
  return HttpClientXml.put(endPoint, data);
};

const getTodayAppointment = async () => {
  let endPoint = "get-all-booking-date";
  return HttpClientXml.get(endPoint);
};

const urgentBlockDateTime = async (data) => {
  let endPoint = "add-blockdatetime-urgent";
  return HttpClientXml.post(endPoint, data);
};

//////////////////
const addDocumentType = async (data) => {
  let endPoint = "add-documents";
  return HttpClientXml.post(endPoint, data);
};
const viewUploadedDoc = async (data) => {
  let endPoint = "view-uploaded-doc";
  return HttpClientXml.post(endPoint, data);
};
const getAllDocumentTypes = async () => {
  let endPoint = "view-documents";
  return HttpClientXml.get(endPoint);
};
const updateDocumentType = async (id, data) => {
  let endPoint = `update-documents/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const deleteDocumentType = async (id) => {
  let endPoint = `delete-documents/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
const deleteAssignedStaff = async (id) => {
  let endPoint = `delete-assigned-user/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
//////////////////
const addService = async (data) => {
  let endPoint = "add-service";
  return HttpClientXml.post(endPoint, data);
};
const addStaff = async (data) => {
  let endPoint = "staff";
  return HttpClientXml.post(endPoint, data);
};
const assignStaff = async (data) => {
  let endPoint = "assign-user";
  return HttpClientXml.post(endPoint, data);
};
const getAllServices = async () => {
  let endPoint = "view-service";
  return HttpClientXml.get(endPoint);
};
const updateService = async (id, data) => {
  let endPoint = `update-service/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateStaff = async (id, data) => {
  let endPoint = `staff/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const deleteService = async (id) => {
  let endPoint = `delete-service/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
/////////////////////
const getAllUsers = async () => {
  let endPoint = "view-users";
  return HttpClientXml.get(endPoint);
};
const getUserPaymentHistory = async (data) => {
  let endPoint = "payment-history";
  return HttpClientXml.get(endPoint);
};
const userPayment = async (data) => {
  let endPoint = "payment-history";
  return HttpClientXml.post(endPoint, data);
};
const assignService = async (data) => {
  let endPoint = "assign-service";
  return HttpClientXml.post(endPoint, data);
};
const addReminder = async (data) => {
  let endPoint = "calender-note";
  return HttpClientXml.post(endPoint, data);
};

const getAssignedServicesByUser = async (data) => {
  let endPoint = "single-assigned-user";
  return HttpClientXml.post(endPoint, data);
};
const setNoteToAssignedService = async (data) => {
  let endPoint = "service-note";
  return HttpClientXml.post(endPoint, data);
};
const updateAssignedServiceStatus = async (data) => {
  let endPoint = "status-change";
  return HttpClientXml.post(endPoint, data);
};
//////////////////
const addPaymentLink = async (data) => {
  let endPoint = "service-payment";
  return HttpClientXml.post(endPoint, data);
};
const getAllPaymentLink = async () => {
  let endPoint = "service-payment";
  return HttpClientXml.get(endPoint);
};
const getAllCalenderReminderForDashboard = async () => {
  let endPoint = "calender-note";
  return HttpClientXml.get(endPoint);
};
const getCalenderReminderByUserId = async (id) => {
  let endPoint = "user-wise-calender-note/" + id;
  return HttpClientXml.get(endPoint);
};
const updatePaymentLink = async (id, data) => {
  let endPoint = `service-payment/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateCalenderReminder = async (id, data) => {
  let endPoint = `calender-note/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const deletePaymentLink = async (id) => {
  let endPoint = `service-payment/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
const deleteCalenderReminder = async (id) => {
  let endPoint = `calender-note/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const getPaymentHistoryByUserId = async (id) => {
  let endPoint = "user-payment-history/" + id;
  return HttpClientXml.get(endPoint);
};

// add-blockdatetime-urgent
export default {
  getPaymentHistoryByUserId,
  deleteAssignedStaff,
  getAllCalenderReminderForDashboard,
  viewUploadedDoc,
  addPaymentLink,
  deleteCalenderReminder,
  updateCalenderReminder,
  addReminder,
  getAllPaymentLink,
  updatePaymentLink,
  deletePaymentLink,
  userPayment,
  getAllUsers,
  getAllStaffs,
  assignService,
  getCalenderReminderByUserId,
  getAssignedServicesByUser,
  setNoteToAssignedService,
  updateAssignedServiceStatus,
  getUserPaymentHistory,
  addService,
  addStaff,
  assignStaff,
  getAllServices,
  updateService,
  updateStaff,
  deleteService,
  deleteStaff,
  deleteDocumentType,
  updateDocumentType,
  getAllDocumentTypes,
  addDocumentType,

  rescheduleBooking,
  getTime,
  addBlog,
  getBlog,
  updateBlog,
  deleteBlog,
  viewUserContact,
  viewUserEmail,
  viewWaitListAppointment,
  viewAppointmentData,
  viewCancelAppointment,
  cancelAppointmentById,
  viewBookingTimeByDate,
  blockDateTime,
  viewblockDateTime,
  viewblockByDateAndTime,
  viewUrgentBlockByDateAndTime,
  serviceTypeId,
  viewBlockdate,
  deleteBlockedDate,
  viewAllBlockedDateTime,
  deleteAllBlockedDate,
  getTodayAppointment,
  viewAllUrgentAppointment,
  getInitialBookignAppointment,
  urgentBlockDateTime,
  viewUrgentBlockdate,
  viewUrgentblockDateTime,
  urgentDeleteBlockedDate,
  urgentDeleteAllBlockedDate,
  userContactDetails,
};
